// import store from "../store"
import { getInstance } from '../auth';
import { UserService } from '../services';
// import { router } from "../helpers"

// import { getInstance } from "../auth";

export function handleHttpResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text)
        if(!response.ok) {
            if (response.status == 401 && data.shouldRefreshToken) {
                if(getInstance().isAuthenticated)
                    location.reload()
                else {
                    //router.push("/", () => {})
                    UserService.refreshToken()
                }
            }
            const error = (data && data.message) || response.statusText
            return Promise.reject(error)
            // return { data: null }
        }
        // if(data.errors && data.errors.length > 0) {
        //     return Promise.reject(JSON.parse(data.errors[0].message))
        // }
        return data.data
    })
}